import React, { useEffect, useState, createElement } from 'react';
import { CheckCircle2, XCircle, Clock, Star, FileText, Zap, ShieldCheck, Users, ChevronDown, ArrowRight, MessageSquare, Check, Beef, Calculator, TrendingUp, Percent, Utensils, Smartphone } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}
// --- Sub-components ---
const CountdownTimer = () => {
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 27,
    seconds: 35
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) return {
          ...prev,
          seconds: prev.seconds - 1
        };
        if (prev.minutes > 0) return {
          ...prev,
          minutes: prev.minutes - 1,
          seconds: 59
        };
        if (prev.hours > 0) return {
          ...prev,
          hours: prev.hours - 1,
          minutes: 59,
          seconds: 59
        };
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  return <div className="flex gap-2 font-mono text-xl md:text-2xl font-bold text-white" data-id="element-1">
      <div className="bg-[#800000] px-2 py-1 rounded border border-white/20" data-id="element-2">
        {String(timeLeft.hours).padStart(2, '0')}h
      </div>
      <span className="text-white" data-id="element-3">:</span>
      <div className="bg-[#800000] px-2 py-1 rounded border border-white/20" data-id="element-4">
        {String(timeLeft.minutes).padStart(2, '0')}m
      </div>
      <span className="text-white" data-id="element-5">:</span>
      <div className="bg-[#800000] px-2 py-1 rounded border border-white/20" data-id="element-6">
        {String(timeLeft.seconds).padStart(2, '0')}s
      </div>
    </div>;
};
const FloatingNotification = () => {
  const [visible, setVisible] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [hasScrolled, setHasScrolled] = useState(false);
  const notifications = [{
    n: 'Jorge L.',
    l: 'Buenos Aires',
    t: 'hace 2 min'
  }, {
    n: 'Ricardo M.',
    l: 'Córdoba',
    t: 'hace 5 min'
  }, {
    n: 'Carlos R.',
    l: 'Rosario',
    t: 'hace 8 min'
  }, {
    n: 'Daniel F.',
    l: 'Mendoza',
    t: 'hace 12 min'
  }, {
    n: 'Miguel A.',
    l: 'Salta',
    t: 'hace 15 min'
  }, {
    n: 'Sebastian G.',
    l: 'Tucumán',
    t: 'hace 20 min'
  }, {
    n: 'Facundo S.',
    l: 'Santa Fe',
    t: 'hace 25 min'
  }, {
    n: 'Matias P.',
    l: 'Mar del Plata',
    t: 'hace 30 min'
  }, {
    n: 'Lucas B.',
    l: 'La Plata',
    t: 'hace 45 min'
  }, {
    n: 'Cristian V.',
    l: 'Neuquén',
    t: 'hace 1 hora'
  }, {
    n: 'Alejandro M.',
    l: 'Posadas',
    t: 'hace 2 horas'
  }, {
    n: 'Roberto T.',
    l: 'Resistencia',
    t: 'hace 3 horas'
  }, {
    n: 'Sergio N.',
    l: 'Corrientes',
    t: 'hace 4 horas'
  }, {
    n: 'Gustavo D.',
    l: 'San Juan',
    t: 'hace 5 horas'
  }, {
    n: 'Marcelo C.',
    l: 'San Luis',
    t: 'hace 6 horas'
  }, {
    n: 'Eduardo F.',
    l: 'Catamarca',
    t: 'hace 7 horas'
  }, {
    n: 'Hugo R.',
    l: 'La Rioja',
    t: 'hace 8 horas'
  }];
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 300) {
        setHasScrolled(true);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  useEffect(() => {
    if (!hasScrolled) return;
    const showNext = () => {
      setVisible(true);
      setTimeout(() => {
        setVisible(false);
      }, 4000); // Desaparece a los 4 segundos
    };
    // Primera aparición después del scroll
    const initialDelay = setTimeout(showNext, 2000);
    const interval = setInterval(() => {
      setCurrentIndex(prev => (prev + 1) % notifications.length);
      showNext();
    }, 12000); // Ciclo total (4s visible + 8s espera)
    return () => {
      clearTimeout(initialDelay);
      clearInterval(interval);
    };
  }, [hasScrolled]);
  const current = notifications[currentIndex];
  return <AnimatePresence data-id="element-7">
      {visible && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: -20
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 20
    }} className="fixed bottom-6 left-6 z-50 bg-white shadow-2xl rounded-lg p-4 border border-slate-100 flex items-center gap-4 max-w-sm" data-id="element-8">
          <div className="w-10 h-10 bg-red-100 rounded-full flex items-center justify-center text-[#800000]" data-id="element-9">
            <Check size={20} data-id="element-10" />
          </div>
          <div data-id="element-11">
            <p className="text-xs font-semibold text-slate-500 uppercase tracking-wider" data-id="element-12">
              Compra verificada
            </p>
            <p className="text-sm text-slate-800" data-id="element-13">
              <span className="font-bold" data-id="element-14">{current.n}</span> de {current.l}
              <br data-id="element-15" />
              compró <span className="font-bold" data-id="element-16">sistema completo</span> 🥩
            </p>
            <p className="text-xs text-slate-400 mt-1" data-id="element-17">{current.t}</p>
          </div>
          <button onClick={() => setVisible(false)} className="text-slate-300 hover:text-slate-500" data-id="element-18">
            <XCircle size={16} data-id="element-19" />
          </button>
        </motion.div>}
    </AnimatePresence>;
};
const SectionTitle = ({
  children,
  subtitle,
  light = false
}: {
  children: React.ReactNode;
  subtitle?: string;
  light?: boolean;
}) => <div className="text-center mb-6 md:mb-10" data-id="element-20">
    <h2 className={`text-2xl md:text-5xl font-bold mb-2 md:mb-4 ${light ? 'text-white' : 'text-[#121212]'}`} data-id="element-21">
      {children}
    </h2>
    {subtitle && <p className={`text-sm md:text-lg ${light ? 'text-slate-200' : 'text-slate-600'} max-w-2xl mx-auto font-sans px-4`} data-id="element-22">
        {subtitle}
      </p>}
  </div>;
const CTAButton = ({
  children,
  secondary = false,
  className = '',
  href = '',
  onClick
}: {
  children: React.ReactNode;
  secondary?: boolean;
  className?: string;
  href?: string;
  onClick?: () => void;
}) => {
  const content = <motion.button animate={{
    scale: [1, 1.02, 1]
  }} transition={{
    duration: 2,
    repeat: Infinity,
    ease: 'easeInOut'
  }} className={`
        w-full md:w-auto px-10 py-5 rounded-full font-bold text-lg transition-all transform hover:scale-105 active:scale-95 shadow-xl
        ${secondary ? 'bg-white text-[#800000] border-2 border-slate-200 hover:bg-slate-50' : 'bg-[#800000] text-white hover:bg-[#600000]'}
        ${className}
      `} onClick={onClick} data-id="element-23">
      {children}
    </motion.button>;
  if (href) {
    const isInternal = href.startsWith('#');
    return <a href={href} target={isInternal ? undefined : '_blank'} rel={isInternal ? undefined : 'noopener noreferrer'} className="w-full md:w-auto block" onClick={e => {
      if (isInternal) {
        e.preventDefault();
        const element = document.querySelector(href);
        if (element) element.scrollIntoView({
          behavior: 'smooth'
        });
      }
    }} data-id="element-24">
        {content}
      </a>;
  }
  return content;
};
// --- Main Page ---
export function LandingPage() {
  useEffect(() => {
    // Meta Pixel Code
    if (!window.fbq) {
      const n = window.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!window._fbq) window._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      const t = document.createElement('script');
      t.async = !0;
      t.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(t);
    }
    window.fbq('init', '929826529816985');
    window.fbq('track', 'PageView');
  }, []);
  return <div className="min-h-screen font-sans bg-[#F9F6F2]" data-id="element-25">
      <FloatingNotification data-id="element-26" />

      {/* Top Banner */}
      <div className="bg-[#800000] text-white text-center py-1.5 px-4 text-[10px] md:text-sm font-bold uppercase tracking-widest relative z-20" data-id="element-27">
        🚨 ATENCIÓN MAESTROS CARNICEROS: El precio promocional por lanzamiento
        de la Edición 2026 finaliza hoy.
      </div>

      {/* Hero Section */}
      <header className="relative bg-[#121212] md:min-h-[90svh] md:h-auto flex flex-col text-white overflow-hidden" data-id="element-28">
        <div className="absolute inset-0 opacity-20" data-id="element-29">
          <div className="absolute inset-0 bg-gradient-to-b from-[#800000]/20 to-transparent" data-id="element-30"></div>
        </div>

        <div className="container mx-auto px-4 flex-grow flex flex-col justify-center py-8 md:py-16 relative z-10" data-id="element-31">
          <div className="max-w-4xl mx-auto text-center flex flex-col items-center h-full justify-center" data-id="element-32">
            <div className="flex flex-col items-center" data-id="element-33">
              <motion.div initial={{
              opacity: 0,
              y: 10
            }} animate={{
              opacity: 1,
              y: 0
            }} className="inline-flex items-center gap-2 bg-[#800000]/20 border border-[#800000]/40 px-3 py-0.5 rounded-full text-[#F9F6F2] text-[9px] md:text-sm font-bold mb-2 md:mb-8 backdrop-blur-sm" data-id="element-34">
                🥩 SISTEMA CARNICERÍAS RENTABLES 2026™
              </motion.div>

              <h1 className="text-[24px] md:text-7xl font-bold mb-2 md:mb-8 text-white leading-tight" data-id="element-35">
                La Biblia del Maestro Carnicero.
              </h1>

              <p className="text-sm md:text-2xl text-white/80 mb-4 md:mb-8 max-w-3xl mx-auto leading-relaxed px-4 italic" data-id="element-36">
                El método probado para defender tu margen, optimizar el desposte
                y blindar tu negocio contra la inflación.
              </p>
            </div>

            <motion.div initial={{
            opacity: 0,
            scale: 0.95
          }} animate={{
            opacity: 1,
            scale: 1
          }} transition={{
            delay: 0.2,
            duration: 0.8
          }} className="relative max-w-[240px] md:max-w-3xl mx-auto mb-4 md:mb-12 group" data-id="element-37">
              <div className="absolute inset-0 bg-[#800000] blur-3xl opacity-20 group-hover:opacity-30 transition-opacity duration-700" data-id="element-38"></div>
              <div className="relative z-10 bg-gradient-to-br from-zinc-800 to-zinc-900 p-2 md:p-4 rounded-xl md:rounded-2xl shadow-2xl border border-zinc-700" data-id="element-39">
                <img src="https://cdn.magicpatterns.com/uploads/gukH4ts1JW6siAhQCCrm1g/a_well_lit_indoor_butcher_shop_scene_overall_view_1_web.webp" alt="Sistema Carnicerías Rentables Mockup" className="w-full h-auto rounded-lg md:rounded-xl shadow-lg" data-id="element-40" />
                <div className="absolute -bottom-2 -right-2 bg-[#800000] text-white px-2 py-1 md:p-4 rounded-lg shadow-xl font-bold text-[10px] md:text-base" data-id="element-41">
                  EDICIÓN 2026
                </div>
              </div>
            </motion.div>

            <div className="flex flex-col items-center w-full" data-id="element-42">
              <CTAButton href="#pricing" className="uppercase tracking-wide px-6 py-3 md:px-12 md:py-6 text-sm md:text-xl mb-3 md:mb-6" data-id="element-43">
                → QUIERO PROFESIONALIZAR MI CARNICERÍA HOY
              </CTAButton>

              <div className="flex justify-center gap-3 md:gap-6 text-white/60 font-medium text-[8px] md:text-sm mb-4 md:mb-0" data-id="element-44">
                <div className="flex items-center gap-1 bg-white/5 px-2 py-0.5 rounded-full border border-white/10" data-id="element-45">
                  +350 Páginas prácticas
                </div>
                <div className="flex items-center gap-1 bg-white/5 px-2 py-0.5 rounded-full border border-white/10" data-id="element-46">
                  <Zap size={10} className="md:w-3.5 md:h-3.5" data-id="element-47" /> Acceso
                  Instantáneo
                </div>
                <div className="flex items-center gap-1 bg-white/5 px-2 py-0.5 rounded-full border border-white/10" data-id="element-48">
                  <ShieldCheck size={10} className="md:w-3.5 md:h-3.5" data-id="element-49" />{' '}
                  Garantía 7 días
                </div>
              </div>
            </div>

            <div className="bg-[#1a1a1a] border border-white/10 rounded-xl p-2 md:p-6 shadow-2xl inline-block self-center hidden md:block" data-id="element-50">
              <p className="text-white/60 font-bold uppercase tracking-widest text-[10px] md:text-xs mb-2 md:mb-3" data-id="element-51">
                ⏰ EL PRECIO PROMOCIONAL CIERRA EN:
              </p>
              <CountdownTimer data-id="element-52" />
            </div>
          </div>
        </div>
      </header>

      {/* Stats Section */}
      <section className="py-6 md:py-12 bg-[#800000] text-white" data-id="element-53">
        <div className="container mx-auto px-4" data-id="element-54">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-8 max-w-4xl mx-auto text-center" data-id="element-55">
            {[{
            label: 'Carniceros',
            value: '+1.200'
          }, {
            label: 'Módulos',
            value: '6'
          }, {
            label: 'Páginas',
            value: '350+'
          }, {
            label: 'Calificación',
            value: '4.9/5',
            stars: true
          }].map((stat, i) => <div key={i} data-id="element-56">
                <p className="text-3xl md:text-4xl font-bold mb-1" data-id="element-57">
                  {stat.value}
                </p>
                {stat.stars && <div className="flex justify-center text-yellow-500 mb-1" data-id="element-58">
                    {[...Array(5)].map((_, j) => <Star key={j} size={14} fill="currentColor" data-id="element-59" />)}
                  </div>}
                <p className="text-[10px] md:text-xs uppercase tracking-widest font-bold opacity-80" data-id="element-60">
                  {stat.label}
                </p>
              </div>)}
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <section className="py-10 md:py-24 bg-white" data-id="element-61">
        <div className="container mx-auto px-4" data-id="element-62">
          <div className="grid md:grid-cols-3 gap-6 md:gap-8 max-w-6xl mx-auto" data-id="element-63">
            {[{
            n: 'Jorge L.',
            l: 'Buenos Aires',
            q: 'Con la calculadora del Bono 1 supe exactamente cómo acomodar los precios para no perder con la suba del lunes.',
            i: 'JL'
          }, {
            n: 'Ricardo M.',
            l: 'Maestro Carnicero',
            q: 'Empecé a hacer mis propios chorizos premium y hoy son mi producto más vendido.',
            i: 'RM'
          }, {
            n: 'Carlos R.',
            l: 'Rosario',
            q: 'Por fin algo que habla en argentino y entiende nuestra media res.',
            i: 'CR'
          }].map((test, i) => <div key={i} className="bg-[#F9F6F2] p-8 rounded-2xl shadow-sm border border-slate-100" data-id="element-64">
                <div className="flex gap-1 mb-4 text-[#800000]" data-id="element-65">
                  {[...Array(5)].map((_, j) => <Star key={j} size={16} fill="currentColor" data-id="element-66" />)}
                </div>
                <p className="text-[#121212] italic mb-6 leading-relaxed" data-id="element-67">
                  "{test.q}"
                </p>
                <div className="flex items-center gap-4" data-id="element-68">
                  <div className="w-10 h-10 bg-[#800000] rounded-full flex items-center justify-center font-bold text-white" data-id="element-69">
                    {test.i}
                  </div>
                  <div data-id="element-70">
                    <p className="font-bold text-[#121212]" data-id="element-71">{test.n}</p>
                    <p className="text-xs text-slate-500" data-id="element-72">{test.l}</p>
                  </div>
                </div>
              </div>)}
          </div>
        </div>
      </section>

      {/* Problem Section */}
      <section className="py-10 md:py-24 bg-[#121212] text-white" data-id="element-73">
        <div className="container mx-auto px-4" data-id="element-74">
          <SectionTitle light subtitle="Baja el camión. Los precios subieron. Los clientes se quejan. No es falta de oficio, es falta de un sistema de gestión real." data-id="element-75">
            ¿Cuántas medias reses vas a despostar sintiendo que el dinero se te
            escapa de las manos?
          </SectionTitle>

          <div className="grid md:grid-cols-2 gap-3 md:gap-4 max-w-4xl mx-auto mt-8 md:mt-12" data-id="element-76">
            {['Sin saber calcular el Costo de Reposición real.', 'Con mermas invisibles que se comen tu ganancia.', 'Perdiendo clientes por no ofrecer cortes de autor.', 'Con miedo a clausuras de Bromatología.'].map((item, i) => <div key={i} className="bg-white/5 border border-white/10 p-4 md:p-6 rounded-xl flex gap-3 md:gap-4 items-start" data-id="element-77">
                <XCircle className="text-[#800000] shrink-0 mt-1" size={20} data-id="element-78" />
                <p className="text-white/90 font-medium text-base md:text-lg" data-id="element-79">
                  {item}
                </p>
              </div>)}
          </div>

          <div className="mt-10 md:mt-16 max-w-3xl mx-auto bg-[#800000]/10 border-l-8 border-[#800000] p-6 md:p-8 rounded-r-2xl shadow-sm text-center" data-id="element-80">
            <p className="text-2xl md:text-3xl font-bold text-white italic" data-id="element-81">
              ¿Y si esta fuera la última vez que enfrentás una suba de precios
              sin saber qué hacer?
            </p>
          </div>
        </div>
      </section>

      {/* Product Hero */}
      <section className="py-10 md:py-24 bg-white" data-id="element-82">
        <div className="container mx-auto px-4 text-center" data-id="element-83">
          <div className="inline-block bg-[#800000] text-white px-5 py-1.5 rounded-full font-bold text-xs uppercase tracking-widest mb-6 md:mb-8" data-id="element-84">
            SOLUCIÓN INTEGRAL
          </div>
          <h2 className="text-3xl md:text-6xl font-bold mb-4 md:mb-6 text-[#121212]" data-id="element-85">
            🥩 SISTEMA CARNICERÍAS RENTABLES 2026™
          </h2>
          <p className="text-base md:text-2xl text-slate-600 mb-8 md:mb-12 max-w-3xl mx-auto" data-id="element-86">
            Ebook Central + 5 Bonos Estratégicos. 100% adaptado a la realidad de
            Argentina y LATAM. No más improvisación.
          </p>

          <div className="max-w-4xl mx-auto mb-8 md:mb-16 relative" data-id="element-87">
            <img src="https://images.unsplash.com/photo-1551028150-64b9f398f678?auto=format&fit=crop&q=80&w=1200" alt="Pack Completo" className="w-full h-auto rounded-2xl md:rounded-3xl shadow-2xl border border-slate-200" data-id="element-88" />
          </div>
        </div>
      </section>

      {/* Modules */}
      <section className="py-10 md:py-24 bg-[#F9F6F2]" data-id="element-89">
        <div className="container mx-auto px-4" data-id="element-90">
          <SectionTitle subtitle="La estructura maestra para transformar tu negocio." data-id="element-91">
            📚 MÓDULOS DEL EBOOK CENTRAL
          </SectionTitle>

          <div className="grid md:grid-cols-2 gap-6 md:gap-8 max-w-6xl mx-auto" data-id="element-92">
            {[{
            t: 'MÓDULO 1: LA BIBLIA DEL DESPOSTE',
            d: 'Aprovechamiento total de la res. Técnicas criollas para no desperdiciar ni un gramo.',
            icon: <Beef size={24} data-id="element-93" />
          }, {
            t: 'MÓDULO 2: INGENIERÍA DE LA MERMA',
            d: 'Recuperación de grasas y huesos. Cómo convertir el desperdicio en dinero contante y sonante.',
            icon: <TrendingUp size={24} data-id="element-94" />
          }, {
            t: 'MÓDULO 3: PSICOLOGÍA DEL MOSTRADOR',
            d: 'Cómo subir el ticket promedio. El arte de vender lo que a vos te conviene, no solo lo que el cliente pide.',
            icon: <Users size={24} data-id="element-95" />
          }, {
            t: 'MÓDULO 4: LA VACA ENTERA',
            d: 'Rentabilidad en cortes de segunda. Secretos para que el osobuco y la falda rindan como lomo.',
            icon: <Utensils size={24} data-id="element-96" />
          }].map((m, i) => <div key={i} className="bg-white p-8 rounded-2xl shadow-xl border-t-4 border-[#800000] hover:scale-[1.02] transition-all" data-id="element-97">
                <div className="text-[#800000] mb-4" data-id="element-98">{m.icon}</div>
                <h3 className="text-xl font-bold mb-3 text-[#121212]" data-id="element-99">{m.t}</h3>
                <p className="text-slate-600 leading-relaxed" data-id="element-100">{m.d}</p>
              </div>)}
          </div>
        </div>
      </section>

      {/* Bonuses */}
      <section className="py-10 md:py-24 bg-white" data-id="element-101">
        <div className="container mx-auto px-4" data-id="element-102">
          <SectionTitle subtitle="Valor total bonos: $55.000 → GRATIS con tu pack" data-id="element-103">
            🎁 5 BONOS ESTRATÉGICOS
          </SectionTitle>

          <div className="grid md:grid-cols-3 gap-4 md:gap-6 max-w-6xl mx-auto" data-id="element-104">
            {[{
            t: 'BONO 1: CALCULADORA DE COSTOS PRO',
            d: 'Planilla Anti-Inflación. Ponés el precio del kilo vivo y te da el costo de cada corte.',
            icon: <Calculator data-id="element-105" />
          }, {
            t: 'BONO 2: MANUAL CARNICERÍA BOUTIQUE',
            d: 'Tomahawk y Cortes de Selección. Cómo cobrar el doble por lo mismo.',
            icon: <Star data-id="element-106" />
          }, {
            t: 'BONO 3: FACTURA Y ELABORADOS',
            d: 'Chorizos y Milanesas de Autor. El margen real está en lo que vos fabricás.',
            icon: <Utensils data-id="element-107" />
          }, {
            t: 'BONO 4: PROTOCOLOS ANTI-CLAUSURA',
            d: 'Checklist de Inocuidad. Que Bromatología entre y salga sin anotar nada.',
            icon: <ShieldCheck data-id="element-108" />
          }, {
            t: 'BONO 5: WHATSAPP CÁRNICO',
            d: 'Venta digital por estados y grupos. Tu carnicería abierta las 24 horas.',
            icon: <Smartphone data-id="element-109" />
          }].map((b, i) => <div key={i} className="bg-[#F9F6F2] p-6 rounded-2xl border border-slate-100 relative overflow-hidden group" data-id="element-110">
                <div className="absolute top-0 right-0 bg-[#800000] text-white text-[10px] font-bold px-3 py-1 rounded-bl-lg uppercase" data-id="element-111">
                  Gratis
                </div>
                <div className="text-[#800000] mb-4 group-hover:scale-110 transition-transform" data-id="element-112">
                  {b.icon}
                </div>
                <h4 className="text-lg font-bold mb-2 text-[#121212]" data-id="element-113">{b.t}</h4>
                <p className="text-slate-600 text-sm leading-relaxed" data-id="element-114">{b.d}</p>
              </div>)}
          </div>
        </div>
      </section>

      {/* Pricing Section */}
      <section className="py-6 md:py-16 bg-[#121212] text-white" id="pricing" data-id="element-115">
        <div className="container mx-auto px-4" data-id="element-116">
          <div className="text-center mb-4 md:mb-8" data-id="element-117">
            <h2 className="text-2xl md:text-5xl font-bold mb-2 text-white" data-id="element-118">
              LLEVATE TU PACK COMPLETO ⭐
            </h2>
            <p className="text-sm md:text-lg text-slate-200 max-w-2xl mx-auto font-sans px-4" data-id="element-119">
              Acceso inmediato a todo el material en formato PDF.
            </p>
          </div>

          <div className="max-w-2xl mx-auto" data-id="element-120">
            <div className="bg-[#1a1a1a] rounded-2xl md:rounded-3xl p-5 md:p-10 text-white shadow-2xl flex flex-col border-4 border-[#800000] relative" data-id="element-121">
              <div className="text-center mb-3 md:mb-6" data-id="element-122">
                <h3 className="text-lg md:text-2xl font-bold mb-1" data-id="element-123">
                  SISTEMA CARNICERÍAS RENTABLES
                </h3>
                <p className="text-white/60 text-[10px] md:text-xs" data-id="element-124">
                  Ebook Central + 5 Bonos
                </p>
              </div>

              <div className="text-center mb-3 md:mb-6" data-id="element-125">
                <p className="text-zinc-500 line-through text-xs md:text-lg mb-0.5" data-id="element-126">
                  $65.000 ARS
                </p>
                <p className="text-3xl md:text-6xl font-bold text-[#800000]" data-id="element-127">
                  $19.990
                </p>
                <p className="text-xs md:text-lg font-medium" data-id="element-128">ARS</p>
              </div>

              <div className="flex flex-col items-center mb-4 md:mb-8" data-id="element-129">
                <p className="text-white/60 font-bold uppercase tracking-widest text-[9px] md:text-[10px] mb-2" data-id="element-130">
                  ⏰ LA OFERTA TERMINA EN:
                </p>
                <CountdownTimer data-id="element-131" />
              </div>

              <ul className="grid grid-cols-1 md:grid-cols-2 gap-x-4 gap-y-1.5 md:gap-y-3 mb-5 md:mb-8" data-id="element-132">
                {['Módulos de Desposte y Merma', 'Calculadora de Costos Anti-Inflación', 'Manual de Cortes Boutique', 'Protocolos de Inocuidad', 'Estrategia de Venta por WhatsApp', 'Acceso inmediato para siempre'].map((item, i) => <li key={i} className="flex items-center gap-2 text-[11px] md:text-sm font-medium" data-id="element-133">
                    <CheckCircle2 size={14} className="text-[#800000] shrink-0 md:w-4 md:h-4" data-id="element-134" />
                    <span data-id="element-135">{item}</span>
                  </li>)}
              </ul>

              <CTAButton href="https://checkout.guiadigital360.online/cart/44952300519493:1" className="w-full py-3.5 md:py-5 text-base md:text-xl" data-id="element-136">
                → QUIERO EL SISTEMA COMPLETO AHORA
              </CTAButton>

              <p className="mt-3 md:mt-5 text-center text-[#800000] font-bold text-[9px] md:text-sm" data-id="element-137">
                ⚠️ Después del contador, el precio sube $10.000.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Comparison Table */}
      <section className="py-10 md:py-24 bg-white" data-id="element-138">
        <div className="container mx-auto px-4" data-id="element-139">
          <SectionTitle subtitle="La diferencia entre un negocio que sobrevive y uno que prospera." data-id="element-140">
            ⚖️ ¿CUÁNTO CUESTA NO TENERLO?
          </SectionTitle>

          {/* Mobile View: Stacked Cards */}
          <div className="block md:hidden space-y-4 max-w-sm mx-auto" data-id="element-141">
            {[{
            s: 'Sube el frigorífico',
            no: 'Perdés margen o clientes',
            yes: 'Blindás tu ganancia con la calculadora.'
          }, {
            s: 'Bromatología visita',
            no: 'Miedo y riesgo de multas',
            yes: 'Protocolo Bono 4: Todo en regla.'
          }, {
            s: 'Sobran recortes',
            no: 'Se tiran o regalan',
            yes: 'Bono 3: Se hacen hamburguesas gourmet.'
          }].map((row, i) => <div key={i} className="border border-slate-200 rounded-xl overflow-hidden shadow-sm" data-id="element-142">
                <div className="bg-[#121212] px-4 py-2 text-xs font-bold text-white uppercase tracking-wider" data-id="element-143">
                  {row.s}
                </div>
                <div className="grid grid-cols-2 text-[11px] leading-tight" data-id="element-144">
                  <div className="bg-red-50 p-4 text-red-700 italic border-r border-white" data-id="element-145">
                    <span className="block font-bold text-[9px] uppercase mb-1 opacity-60" data-id="element-146">
                      Sin el Sistema
                    </span>
                    {row.no}
                  </div>
                  <div className="bg-green-50 p-4 text-green-800 font-bold" data-id="element-147">
                    <span className="block font-bold text-[9px] uppercase mb-1 opacity-60" data-id="element-148">
                      Con el Sistema
                    </span>
                    {row.yes}
                  </div>
                </div>
              </div>)}
          </div>

          {/* Desktop View: Optimized Table */}
          <div className="hidden md:block max-w-4xl mx-auto overflow-hidden rounded-2xl border border-slate-200 shadow-xl" data-id="element-149">
            <table className="w-full text-left border-collapse" data-id="element-150">
              <thead data-id="element-151">
                <tr className="bg-[#121212] text-white" data-id="element-152">
                  <th className="p-6 font-bold" data-id="element-153">SITUACIÓN</th>
                  <th className="p-6 font-bold" data-id="element-154">❌ SIN EL SISTEMA</th>
                  <th className="p-6 font-bold" data-id="element-155">✅ CON EL SISTEMA</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-100" data-id="element-156">
                {[{
                s: 'Sube el frigorífico',
                no: 'Perdés margen o clientes',
                yes: 'Blindás tu ganancia con la calculadora.'
              }, {
                s: 'Bromatología visita',
                no: 'Miedo y riesgo de multas',
                yes: 'Protocolo Bono 4: Todo en regla.'
              }, {
                s: 'Sobran recortes',
                no: 'Se tiran o regalan',
                yes: 'Bono 3: Se hacen hamburguesas gourmet.'
              }].map((row, i) => <tr key={i} className={i % 2 === 0 ? 'bg-white' : 'bg-slate-50'} data-id="element-157">
                    <td className="p-6 text-sm font-bold text-[#121212]" data-id="element-158">
                      {row.s}
                    </td>
                    <td className="p-6 text-sm text-red-700 italic" data-id="element-159">
                      {row.no}
                    </td>
                    <td className="p-6 text-sm font-bold text-green-700" data-id="element-160">
                      {row.yes}
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>
        </div>
      </section>

      {/* Guarantee */}
      <section className="py-10 md:py-24 bg-[#800000]/5" data-id="element-161">
        <div className="container mx-auto px-4 text-center" data-id="element-162">
          <div className="max-w-3xl mx-auto bg-white p-8 md:p-16 rounded-2xl md:rounded-3xl border-2 border-[#800000] shadow-xl" data-id="element-163">
            <ShieldCheck size={60} className="text-[#800000] mx-auto mb-6 md:mb-8" data-id="element-164" />
            <h2 className="text-2xl md:text-4xl font-bold mb-4 md:mb-6 text-[#121212]" data-id="element-165">
              GARANTÍA DE SATISFACCIÓN DE 7 DÍAS
            </h2>
            <p className="text-lg md:text-xl text-slate-600 mb-6 md:mb-8 leading-relaxed" data-id="element-166">
              Si el material no mejora tu rentabilidad, te devolvemos el 100%.{' '}
              <br data-id="element-167" />
              <span className="text-xl md:text-2xl font-bold text-[#800000] block mt-2 md:mt-4 uppercase" data-id="element-168">
                Sin preguntas.
              </span>
            </p>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="py-10 md:py-16 bg-[#121212] text-white/40 border-t border-white/5" data-id="element-169">
        <div className="container mx-auto px-4 text-center" data-id="element-170">
          <p className="font-bold text-white text-2xl mb-4" data-id="element-171">
            🥩 SISTEMA CARNICERÍAS RENTABLES™
          </p>
          <p className="text-sm mb-8 max-w-2xl mx-auto leading-relaxed" data-id="element-172">
            El método definitivo para el carnicero moderno que busca
            profesionalizar su oficio y proteger su capital.
          </p>
          <p className="text-xs" data-id="element-173">© 2026 — Todos los derechos reservados.</p>
        </div>
      </footer>
    </div>;
}